import { type ModuleConfigState } from '@pixacare/forms';

/**
 * Stable empty auto-module list shared across the grid. Returning this constant
 * (instead of a fresh `[]`) keeps `@for` inputs reference-stable and avoids
 * allocating on every change-detection pass.
 */
export const EMPTY_AUTO_MODULES: ModuleConfigState[] = [];
